<div class="toast-stack" aria-live="polite">
  @for (toast of toasts; track toast.id) {
    <div
      class="toast"
      [class.toast--success]="toast.type === 'success'"
      [class.toast--error]="toast.type === 'error'"
      [class.toast--warning]="toast.type === 'warning'"
      [class.toast--info]="toast.type === 'info'"
      [class.toast--neutral]="toast.type === 'neutral'"
      (mouseenter)="pauseTimer(toast)"
      (mouseleave)="resumeTimer(toast)"
    >
      <span class="toast__icon">
        @switch (toast.type) {
          @case ('success') {
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M2.5 6.25L4.75 8.5L9.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @case ('error') {
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3 3L9 9M9 3L3 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          }
          @case ('warning') {
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M6 3V7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              <circle cx="6" cy="9" r="0.9" fill="currentColor"/>
            </svg>
          }
          @case ('info') {
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="6" cy="3.25" r="0.9" fill="currentColor"/>
              <path d="M6 5.5V9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          }
          @case ('neutral') {
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="2.25" y="1.75" width="7.5" height="8.5" rx="1.25" stroke="currentColor" stroke-width="1.2"/>
              <circle cx="6" cy="4.25" r="0.7" fill="currentColor"/>
              <path d="M6 6V8.1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
            </svg>
          }
        }
      </span>
      <span class="toast__message">{{ toast.message }}</span>
      <span class="toast__countdown">{{ toast.remainingSeconds }}s</span>
      <span class="toast__divider"></span>
      <button type="button" class="toast__close" (click)="dismiss(toast.id)" aria-label="Dismiss notification">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3 3L9 9M9 3L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  }
</div>
